import BoxImage from "@components/BoxImage";
import BoxVideoThumbnail from "@components/BoxVideoThumbnail";
import { getRemoveUrlNameFromField } from "@helpers/string";
import { FormApi } from "final-form";
import { useEffect, useState } from "react";
import styles from "./ImagePreview.module.scss";

interface IImagePreviewProps {
  url: string;
  fieldName: string;
  form: FormApi<Record<string, any>, Partial<Record<string, any>>>;
}

const ImagePreview = ({ url, form, fieldName }: IImagePreviewProps) => {
  const [deleteFile, setDeleteFile] = useState(false);

  const handleOnRemove = () => {
    setDeleteFile(true);
    form.change(fieldName, undefined);
  };

  useEffect(() => {
    // Turn remove[fieldName]Url field to true
    if (!deleteFile) {
      return;
    }

    form.change(getRemoveUrlNameFromField(fieldName), true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteFile]);

  return (
    <>
      {!deleteFile && url && (
        <div>
          <div className={styles.Image}>
            {url.includes("mp4") ? (
              <BoxVideoThumbnail url={url} onRemove={handleOnRemove} />
            ) : (
              <BoxImage
                urlImage={url}
                isPreview
                onRemove={handleOnRemove}
                key={url}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ImagePreview;
